<app-section-wrapper-container>
	<form
		class="um-section-parent-container"
		[formGroup]="detailsForm"
		(keypress)="onKeyPress($event)">
		<div>
			<app-input-field
				formControlName="companyName"
				[label]="'customers|record|contact-company-section|field-label|company-name'" />
		</div>

		<app-more-sections label="shared|communication|title">
			<div>
				<app-input-field
					formControlName="email"
					[label]="'customers|record|contact-company-section|field-label|email'" />
				<app-input-field
					formControlName="phoneMobile"
					[label]="'customers|record|contact-company-section|field-label|phone-mobile'" />
			</div>
			<div>
				<app-input-field
					formControlName="phoneFax"
					[label]="'customers|record|contact-company-section|field-label|phone-fax'" />
				<app-input-field
					formControlName="phoneLandline"
					[label]="'customers|record|contact-company-section|field-label|phone-landline'" />
			</div>
		</app-more-sections>

		<app-more-sections label="shared|address-information|title">
			<div>
				<app-input-field
					formControlName="address1"
					[label]="'customers|record|contact-company-section|field-label|address1'" />
				<app-input-field
					formControlName="address2"
					[label]="'customers|record|contact-company-section|field-label|address2'" />
			</div>

			<div>
				<app-input-field
					formControlName="city"
					[label]="'customers|record|contact-company-section|field-label|city'" />
				<app-input-field
					formControlName="postCode"
					[label]="'customers|record|contact-company-section|field-label|post-code'" />
			</div>

			<div>
				<app-input-field
					formControlName="county"
					[label]="'customers|record|contact-company-section|field-label|county'" />
				<app-input-field
					formControlName="state"
					[label]="'customers|record|contact-company-section|field-label|state'" />
			</div>
			<div>
				<app-single-dropdown
					[selectOptions]="countries"
					formControlName="countryId"
					[label]="'customers|record|contact-company-section|field-label|country'" />

				<app-input-field
					formControlName="poBox"
					[label]="'customers|record|contact-company-section|field-label|po-box'" />
			</div>
		</app-more-sections>
	</form>
</app-section-wrapper-container>
